import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const get = async (path, params) => (await axios.get(`${API}${path}`, { params })).data;

// Auth
export const login = (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const logout = () => axios.post(`${API}/auth/logout`).then((r) => r.data);
export const fetchMe = () => get("/auth/me");
export const changePassword = (payload) => axios.post(`${API}/auth/change-password`, payload).then((r) => r.data);
// Two-factor authentication (TOTP)
export const login2fa = (code, trust_device) => axios.post(`${API}/auth/2fa/login`, { code, trust_device }).then((r) => r.data);
export const startTotpSetup = () => axios.post(`${API}/auth/2fa/setup/start`).then((r) => r.data);
export const totpQrUrl = () => `${API}/auth/2fa/setup/qr?t=${Date.now()}`;
export const confirmTotpSetup = (code) => axios.post(`${API}/auth/2fa/setup/confirm`, { code }).then((r) => r.data);
export const fetchTotpStatus = () => get("/auth/2fa/status");
export const revokeTrustedDevice = (id) => axios.delete(`${API}/auth/2fa/trusted-devices/${id}`).then((r) => r.data);
export const resetMember2fa = (id) => axios.post(`${API}/members/${id}/2fa/reset`).then((r) => r.data);
export const placeCall = (number, line) => axios.post(`${API}/call`, line ? { number, line } : { number }).then((r) => r.data);

// Shared app settings
export const fetchWhatsappMessage = (line = "reco_pneus") => get("/settings/whatsapp-message", { line });
export const updateWhatsappMessage = (message, line = "reco_pneus") => axios.put(`${API}/settings/whatsapp-message`, { message }, { params: { line } }).then((r) => r.data);
export const resetWhatsappMessage = (line = "reco_pneus") => axios.delete(`${API}/settings/whatsapp-message`, { params: { line } }).then((r) => r.data);
export const fetchCallAi = (id) => get(`/calls/${id}/ai`);
export const retryCallAi = (id) => axios.post(`${API}/calls/${id}/ai/retry`).then((r) => r.data);

// Expired/invalid session on any non-auth route -> back to the login page.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    if (
      error.response?.status === 401 &&
      !url.includes("/auth/") &&
      typeof window !== "undefined" &&
      !window.location.pathname.startsWith("/connexion")
    ) {
      window.location.assign("/connexion");
    }
    return Promise.reject(error);
  }
);

// Numbers / line
export const fetchNumbers = () => get("/numbers");
export const fetchNumber = (id) => get(`/numbers/${id}`);
export const createNumber = (payload) => axios.post(`${API}/numbers`, payload).then((r) => r.data);
export const deleteNumber = (id) => axios.delete(`${API}/numbers/${id}`).then((r) => r.data);
export const updateNumber = (id, payload) => axios.patch(`${API}/numbers/${id}`, payload).then((r) => r.data);
export const fetchNumberCalls = (id) => get(`/numbers/${id}/calls`, { limit: 50, days: 30 });
export const fetchGroupedCalls = (id, filter = "tous") => get(`/numbers/${id}/calls/grouped`, { filter });
export const fetchNumberStats = (id) => get(`/numbers/${id}/stats`, { days: 30 });
export const fetchNumberMembers = (id) => get(`/numbers/${id}/members`);

// Calls / recordings
export const recordingUrl = (id) => `${API}/calls/${id}/recording`;

// Stats
export const fetchStats = () => get("/stats", { days: 30 });

// Upstream status
export const fetchUpstreamStatus = () => get("/upstream-status");

// Members
export const fetchMembers = () => get("/members");
export const createMember = (payload) => axios.post(`${API}/members`, payload).then((r) => r.data);
export const updateMember = (id, payload) => axios.patch(`${API}/members/${id}`, payload).then((r) => r.data);
export const deleteMember = (id) => axios.delete(`${API}/members/${id}`).then((r) => r.data);

// Contacts
export const fetchContacts = () => get("/contacts");
export const fetchContact = (key) => get(`/contacts/${key}`);
export const createContact = (payload) => axios.post(`${API}/contacts`, payload).then((r) => r.data);
export const updateContact = (key, payload) => axios.patch(`${API}/contacts/${key}`, payload).then((r) => r.data);
export const deleteContact = (key) => axios.delete(`${API}/contacts/${key}`).then((r) => r.data);

// Stations ("Postes")
export const fetchStations = () => get("/stations");
export const fetchStation = (ext) => get(`/stations/${ext}`);
export const updateStation = (ext, payload) => axios.patch(`${API}/stations/${ext}`, payload).then((r) => r.data);
export const fetchMyStation = (memberId) => get("/my-station", memberId ? { member_id: memberId } : undefined);

export const ROLE_LABELS = { admin: "Administrateur", superviseur: "Superviseur", agent: "Agent" };
